import type { StateCreator } from 'zustand';
import type { CanvasImage } from '@/utils/canvas';

export interface CanvasSlice {
  canvasImages: CanvasImage[];
  setCanvasImages: (images: CanvasImage[]) => void;
}

export const canvasInitialState = {
  canvasImages: [] as CanvasImage[],
};

export const createCanvasSlice: StateCreator<
  CanvasSlice,
  [],
  [],
  CanvasSlice
> = (set) => ({
  ...canvasInitialState,

  setCanvasImages: (canvasImages) => set({ canvasImages }),
});
